import React from 'react';
import { ScheduleIndicationForm } from '../components';

export function ScheduleIndicationPage(): JSX.Element {
  return (
    <>
      <ScheduleIndicationForm />
    </>
  );
}

export default ScheduleIndicationPage;
